import type { DiscoveryMovie, MovieSummary } from './types';

export type BrowseMovie = MovieSummary | DiscoveryMovie;

export function isSummary(movie: BrowseMovie): movie is MovieSummary {
  return 'availability' in movie;
}
